import { debugInfo } from "@config"
import { isMultilingualFlag } from '../util'
import { getMultiRes } from './MultiCache'

const parseTreeJson = (tree = {}, multiRes) => {
  const dfs = (node) => {
    if (Array.isArray(node)) {
      node.forEach(item => {
        if (Object.prototype.toString.call(item) === '[object Object]' || Array.isArray(item)) {
          dfs(item);
        }
      });
    } else {
      Object.keys(node).forEach(item => {
        const value = node[item]
        // 多语如果key和value相等的话就不替换了
        if (item.endsWith('_resid') && multiRes[value] && multiRes[value] != value) {
          // 要替换的字段
          const replaceField = item.substring(0, item.length - '_resid'.length)
          // 替换
          node[replaceField] = multiRes[value]
        } else if (item.endsWith('_resid') && window.lang?.pack?.[value]) { // 替换系统词条
          // 要替换的字段
          const replaceField = item.substring(0, item.length - '_resid'.length)
          // 替换
          node[replaceField] = window.lang.pack[value]
        }
        if (Object.prototype.toString.call(value) === '[object Object]' || Array.isArray(value)) {
          dfs(value);
        }
      })
    }
  }
  dfs(tree)
}

const parseEnumJson = (tree = {}, multiRes) => {
  if (!tree) return
  Object.keys(tree).forEach(node => {
    tree[node].forEach(enumItem => {
      Object.keys(enumItem).forEach(item => {
        const value = enumItem[item]
        // 多语如果key和value相等的话就不替换了
        if (item.indexOf('_resid') > -1 && multiRes[value] && multiRes[value] != value) {
          // 要替换的字段
          const replaceField = item.substring(0, item.length - '_resid'.length)
          // 替换
          enumItem[replaceField] = multiRes[value]
        }
      })
    })
  })
}

export const multiInsert = async (meta, billNo, params) => {
  try {
    // 非多语环境不处理
    if (!isMultilingualFlag()) return
    if (!meta.metaResource?.url) {
      debugInfo("当前环境是多语环境，但是后端没有返回URL信息。请检查是否抽取了多语信息。");
      return
    }
    const start = new Date().getTime()
    const multiRes = await getMultiRes(meta.metaResource?.url, billNo, meta.tplId, params)
    if (!multiRes?.data) return
    debugInfo('multiRes', multiRes.data)
    parseTreeJson(meta.children, multiRes.data);
    parseEnumJson(meta.enumData, multiRes.data)
    meta.multiData = multiRes.data
    debugInfo('多语替换耗时', new Date().getTime() - start)
  } catch (error) {
    console.warn('多语处理失败', error)
  }
}
